import { createRoutine, bindRoutineToReduxForm } from 'redux-saga-routines';
import { LIST_EMAILS, UPDATE_EMAILS } from './types';

export const listEmails = createRoutine(LIST_EMAILS);
export const updateEmails = createRoutine(UPDATE_EMAILS);
export const bindedUpdateEmails = bindRoutineToReduxForm(updateEmails);
